import * as React from "react";

function IcPaymentCreditCardUnavailable16(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 16,
    height = 16,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcPaymentCreditCardUnavailable16"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#clip0_11048_6122)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.39884 6H1C0.447715 6 0 6.44772 0 7C0 7.55228 0.447715 8 1 8H6.43906L8.39884 6ZM9.23919 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H11.199L9.23919 8Z"
          fill={accent}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6184 2H2.5C1.11929 2 0 3.11929 0 4.5V11.5C0 12.1505 0.248453 12.743 0.655642 13.1877L2.06599 11.7484C2.024 11.6752 2 11.5904 2 11.5V4.5C2 4.22386 2.22386 4 2.5 4H9.65858L11.6184 2ZM6.99956 11L8.68933 9.27555C8.88071 9.45771 9 9.71492 9 10C9 10.5523 8.55228 11 8 11H7C6.99985 11 6.99971 11 6.99956 11ZM6.01967 12H13.5C13.7761 12 14 11.7761 14 11.5V4.5C14 4.32625 13.9114 4.1732 13.7769 4.08359L15.1816 2.65004C15.6844 3.10733 16 3.76681 16 4.5V11.5C16 12.8807 14.8807 14 13.5 14H4.0599L6.01967 12ZM11 9C10.4477 9 10 9.44772 10 10C10 10.5523 10.4477 11 11 11H12C12.5523 11 13 10.5523 13 10C13 9.44772 12.5523 9 12 9H11Z"
          fill={color}
        />
        <path
          d="M1.17932 14.7965L14.4989 1.20355"
          stroke={color}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11048_6122">
          <rect width={16} height={16} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IcPaymentCreditCardUnavailable16;
